import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  applicantDataSelector,
  artisanDataSelector,
  authCurrentUserSelector,
  authCurrentUserTypeSelector,
  customerDataSelector,
  supplierDataSelector
} from '../../../modules/auth/Selectors';
import { useHistory, useLocation } from 'react-router-dom';
// import { connect } from 'react-redux';
import {
  getUsersAction,
  setSearchValueAction as usersSearch
} from '../../../modules/users/Actions';
// import {} from '../../../modules/users/Selectors'
import {
  getArtisanProductsAction,
  setSearchValueAction as artisanProductSearch
} from '../../../modules/artisanProducts/Actions';
import {
  getArtisanCategoriesAction,
  setSearchValueAction as artisanCategorySearch
} from '../../../modules/artisanCategories/Actions';
import {
  getSupplierCategoriesAction,
  setSearchValueAction as supplierCategorySearch
} from '../../../modules/supplierCategories/Actions';
import {
  getArtisanTagsAction,
  setSearchValueAction as artisanTagsSearch
} from '../../../modules/artisanTags/Actions';
import {
  getSupplierTagsAction,
  setSearchValueAction as supplierTagsSearch
} from '../../../modules/supplierTags/Actions';
import {
  getSupplierProductsAction,
  setSearchValueAction as supplierProductSearch
} from '../../../modules/supplierProducts/Actions';
import {
  getTrainingCentersAction,
  setTrainingCenterSearchValueActon
} from '../../../modules/trainingCenter/Actions';
import { trainingCenterSearchValue } from '../../../modules/trainingCenter/Selectors';
import getLangData from '../../../utils/getLangData';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import Cookie from 'js-cookie';

// import * as Yub from "yub";

const TobBar = props => {
  const { user, userType } = props;
  const history = useHistory();
  const locationHook = useLocation();
  // console.log('hook', locationHook)
  // const { location } = history;
  // const { pathname } = location;
  // console.log('listen',history.listen())
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);
  const {
    searchUsers,
    searchArtisanProducts,
    searchSupplierProducts,
    searchArtisanCategories,
    searchSupplierCategories,
    searchArtisanTags,
    searchSupplierTags,
    getTrainingCenter,
    // search

    usersSearchValue,
    artisanProductSearchValue,
    supplierProductSearchValue,
    artisanTagSearchValue,
    supplierTagsSearchValue,
    artisanCategorySearchValue,
    supplierCategorySearchValue,
    trainingCenterSearchValue,
    // Profile Data

    artisanData,
    supplierData,
    customerData,
    applicantData
  } = props;
  useEffect(() => { }, [user]);
  const { firstName, lastName } = user;
  const [type, setType] = useState('');
  const [locationName, setLocation] = useState(false);
  const userNum = localStorage.getItem('userTypeNum');
  const checkPathName = () => {
    const { pathname } = locationHook;
    if (pathname === '/users') {
      setLocation(true);
    } else if (pathname === '/artisan-products') {
      setLocation(true);
    } else if (pathname === '/supplier-products') {
      setLocation(true);
    } else if (pathname === '/artisan-categories') {
      setLocation(true);
    } else if (pathname === '/supplier-categories') {
      setLocation(true);
    } else if (pathname === '/artisan-tags') {
      setLocation(true);
    } else if (pathname === '/supplier-tags') {
      setLocation(true);
    } else if (pathname === '/training-center') {
      setLocation(true);
    } else {
      setLocation(false);
    }
    // const pathnameCheck = checkPathName()
    // console.log(pathnameCheck)
  };
  // history.listen((location) => {
  //   console.log('loc',location)
  // })
  const langProfile = getLangData().profile_types;

  useEffect(() => {
    checkPathName();
    if (userType[0] === '0' && userNum === null) {
      setType(langProfile.super);
    } else if (userType[0] === '1' && userNum === null) {
      setType(langProfile.admin);
    } else if (userType[0] === '3' && userNum === null) {
      setType(langProfile.artisan);
    } else if (userType[0] === '4' && userNum === null) {
      setType(langProfile.customer);
    } else if (userType[0] === '5' && userNum === null) {
      setType(langProfile.supplier);
    }
    switch (userNum) {
      case '0':
        setType(langProfile.supplier);
        break;
      case '1':
        setType(langProfile.admin);
        break;
      case '3':
        setType(langProfile.artisan);
        break;
      case '4':
        setType(langProfile.customer);
        break;
      case '5':
        setType(langProfile.supplier);
        break;
    }

    console.log(locationHook);
  }, [userNum, history, locationName, locationHook]);
  // const checkPathName = () => {
  //   if (pathname === '/users') {
  //     return true
  //   } else if (pathname === '/artisan-products') {
  //     return true
  //   } else if (pathname === '/supplier-products') {
  //      return true
  //   } else if (pathname === '/artisan-tags') {
  //      return true
  //   } else if (pathname === '/supplier-tags') {
  //      return true
  //   } else {
  //     return false
  //   }
  //   // const pathnameCheck = checkPathName()
  //   // console.log(pathnameCheck)
  // };
  return (
    <div
      className='container'
    // style={{ display: locationName ? 'block' : 'none' }}
    >
      <div className='top--bar row align-items-start'>
        {/* Search  */}
        <div
          className='col-8 col-md-8 py-4 '
          style={{ visibility: locationName ? 'visible' : 'hidden' }}
        >
          <Formik
            initialValues={{
              search: ''
            }}
            onSubmit={values => {
              console.log(values);
              const search = { searchTerm: values.search };

              const { location } = history;
              if (location.pathname === '/users') {
                searchUsers(search);
                usersSearchValue(values.search);
                console.log(history);
                console.log(search);
              } else if (location.pathname === '/artisan-products') {
                searchArtisanProducts(search);
                artisanProductSearchValue(values.search);
              } else if (location.pathname === '/supplier-products') {
                searchSupplierProducts(search);
                supplierProductSearchValue(values.search);
              } else if (location.pathname === '/artisan-categories') {
                searchArtisanCategories(search);
                artisanCategorySearchValue(values.search);
              } else if (location.pathname === '/supplier-categories') {
                searchSupplierCategories(search);
                supplierCategorySearchValue(values.search);
              } else if (location.pathname === '/artisan-tags') {
                searchArtisanTags(search);
                artisanTagSearchValue(values.search);
              } else if (location.pathname === '/supplier-tags') {
                searchSupplierTags(search);
                supplierTagsSearchValue(values.search);
              } else if (location.pathname === '/training-center') {
                getTrainingCentersAction(search);
                trainingCenterSearchValue(values.search);
              }
            }}
          >
            {({ handleSubmit, values, handleChange }) => (
              <form onSubmit={handleSubmit} className='search'>
                <label className='sr-only' htmlFor='search'>
                  Search
                </label>
                <div className='input-group mb-3'>
                  <input
                    type='text'
                    className='form-control'
                    id='search'
                    placeholder={getLangData().search.title}
                    name='search'
                    value={values.search}
                    onChange={handleChange}
                  />
                  <div className='input-group-append'>
                    <button
                      type='submit'
                      className='input-group-text icon-search-warshatna '
                    ></button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>

        {/* User  */}
        <div className='col-4 col-md-4 d-flex py-4  align-items-center'>
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle color='primary' caret>
              {getLangData().fields.languages}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() => {
                  Cookie.set('lang', 'ar');
                  window.location.reload();
                }}
              >
                عربي
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  Cookie.set('lang', 'en');
                  window.location.reload();
                }}
              >
                English
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <div
            className='user--avatar d-flex mx-3'
            style={{ justifyContent: 'center', alignItems: 'center' }}
          >
            {type === 'Super Admin' && (
              <i
                className='fas fa-user-cog'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}
            {/* { type === 'Admin' &&  } */}
            {type === 'Admin' && (
              <i
                className='fas fa-user-cog'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}

            {/* Artisan Check */}

            {type === 'Artisan' && artisanData?.logo && (
              <img
                className='user-image'
                src={
                  // `https://warshatna-users.s3.eu-central-1.amazonaws.com/undefined/09f180a0-3a0d-11eb-bcb8-${user._id}.jpeg` ||
                  artisanData.logo
                }
                alt='User name'
              />
            )}
            {type === 'Artisan' && !artisanData?.logo && (
              <i
                className='fas fa-user'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}

            {/* Supplier Check */}
            {type === 'Supplier' && supplierData?.logo && (
              <img
                className='user-image'
                src={
                  // `https://warshatna-users.s3.eu-central-1.amazonaws.com/undefined/09f180a0-3a0d-11eb-bcb8-${user._id}.jpeg` ||
                  artisanData.logo
                }
                alt='User name'
              />
            )}
            {type === 'Supplier' && !supplierData?.logo && (
              <i
                className='fas fa-user'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}

            {/* Customer Check */}

            {type === 'Customer' && customerData?.logo && (
              <img
                className='user-image'
                src={
                  // `https://warshatna-users.s3.eu-central-1.amazonaws.com/undefined/09f180a0-3a0d-11eb-bcb8-${user._id}.jpeg` ||
                  artisanData.logo
                }
                alt='User name'
              />
            )}
            {type === 'Customer' && !customerData?.logo && (
              <i
                className='fas fa-user'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}

            {/* Applicant Check */}

            {type === 'Applicant' && applicantData?.logo && (
              <img
                className='user-image'
                src={
                  // `https://warshatna-users.s3.eu-central-1.amazonaws.com/undefined/09f180a0-3a0d-11eb-bcb8-${user._id}.jpeg` ||
                  artisanData.logo
                }
                alt='User name'
              />
            )}
            {type === 'Applicant' && !applicantData?.logo && (
              <i
                className='fas fa-user'
                style={{ fontSize: '25px', marginRight: '15px' }}
              ></i>
            )}
            {/* <Link to="/update-user">
              <img
                className="user-image"
                src={
                  // `https://warshatna-users.s3.eu-central-1.amazonaws.com/undefined/09f180a0-3a0d-11eb-bcb8-${user._id}.jpeg` ||
                  '/assets/images/avatar.png'
                }
                alt="User name"
              />
            </Link> */}
            <div className='user-text  d-flex flex-column'>
              <span
                className='name-text mb-2'
                style={{ fontSize: '0.75em', display: 'inline-block' }}
              >{`${firstName} ${lastName}`}</span>
              <span className='type-text'>{type}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: authCurrentUserSelector(state),
    userType: authCurrentUserTypeSelector(state),
    artisanData: artisanDataSelector(state),
    supplierData: supplierDataSelector(state),
    customerData: customerDataSelector(state),
    applicantData: applicantDataSelector(state)
  };
};

const mapDispatchToProps = {
  // Get Actions

  searchUsers: getUsersAction,
  searchArtisanProducts: getArtisanProductsAction,
  searchSupplierProducts: getSupplierProductsAction,
  searchArtisanCategories: getArtisanCategoriesAction,
  searchSupplierCategories: getSupplierCategoriesAction,
  searchArtisanTags: getArtisanTagsAction,
  searchSupplierTags: getSupplierTagsAction,
  getTrainingCenter: getTrainingCentersAction,
  // Set Search Action

  usersSearchValue: usersSearch,
  artisanProductSearchValue: artisanProductSearch,
  supplierProductSearchValue: supplierProductSearch,
  artisanTagSearchValue: artisanTagsSearch,
  supplierTagsSearchValue: supplierTagsSearch,
  artisanCategorySearchValue: artisanCategorySearch,
  supplierCategorySearchValue: supplierCategorySearch,
  trainingCenterSearchValue: setTrainingCenterSearchValueActon
};

export default connect(mapStateToProps, mapDispatchToProps)(TobBar);
